import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, FormGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"

class BulkProcessModal extends Component {
    _handleChangeNote = (e) => {
        const {value} = e.target
        const {onChangeNote} = this.props

        if (typeof onChangeNote === 'function') {
            onChangeNote(value)
        }
    }

    _onClickApproved = () => {
        const {onApproved} = this.props

        if (typeof onApproved === 'function') {
            onApproved()
        }
    }

    _onClickRejected = () => {
        const {onRejected} = this.props

        if (typeof onRejected === 'function') {
            onRejected()
        }
    }

    render() {
        const {isOpen, onToggle, loading, error, arrSelected} = this.props

        return (
            <th className='ProcessModal'>
                <Modal isOpen={isOpen} toggle={onToggle}>
                    <ModalHeader toggle={onToggle}>Duyệt generate label cho <strong>{arrSelected.length}</strong> bản
                        ghi</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <label htmlFor="note">Nội dung:</label>
                            <Input type='textarea' onChange={this._handleChangeNote} id='note'
                                   placeholder='Nhập lý do hoặc chú thích, hoặc lý do từ chối'/>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter className='d-flex align-items-center justify-content-between'>
                        <Button color="danger" onClick={this._onClickRejected}>
                            {loading === 'rejected' && <i className='fa fa-spinner fa-spin mr-1'/>}
                            Từ chối
                        </Button>
                        {error && <div className='text-danger'>{error}</div>}
                        <Button color="primary" onClick={this._onClickApproved}>
                            {loading === 'approved' && <i className='fa fa-spinner fa-spin mr-1'/>}
                            Đồng ý
                        </Button>
                    </ModalFooter>
                </Modal>
            </th>
        )
    }
}

BulkProcessModal.propTypes = {
    loading: PropTypes.any,
    arrSelected: PropTypes.array,
    error: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    onChangeNote: PropTypes.func.isRequired,
    onApproved: PropTypes.func.isRequired,
    onRejected: PropTypes.func.isRequired
}

export default BulkProcessModal